$(function(){
    'use strict';

    $('header.primary.sticky').stickyHeader();
    $('.search-drawer').searchDrawer();
    $('nav.primary').dropdown();
    $('.desktop ~ .submenu a, .desktop ~ .submenu button, .mobile button').each(function(i) {
        $(this).attr('tabindex', '-1');
    });


    $('.carousel').on('init', function(ev, el){
        $('video').each(function() {
            this.play();
        });
        $('.slides-placeholder').fadeTo(3000, 0);
    });

    $('.carousel').on('beforeChange', function(ev, slick, currentSlide, nextSlide) {

        $('.slick-slide').eq(nextSlide).find('video').each(function(){
            this.pause();
            this.curretTime= "0";
            this.load();
        });
    });

    $('.carousel').slick({
        adaptiveHeight: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        dots: false,
        fade: true,
        infinite: true,
        speed: 3000,
    });

    if ($('#mc-embedded-subscribe-form').length && getParameterByName('email')) {
        $('#mc-embedded-subscribe-form').find('.email').val(getParameterByName('email'));
    }

    // Open external links in new window
    $('a').on('click', function(e) {
        var external = (
            !this.href.match(new RegExp(window.location.origin))
        );
        console.log(this.href, window.location.origin)
        var pdf = this.href.match(/\.pdf/);

        if (external || pdf) {
            window.open(this.href);
            e.preventDefault();
        }
    });

    // Pagination
    var loading = false;

    $('.torso').on('click', '[data-load-more]', function (e) {
        e.preventDefault();

        if (loading) {
            return;
        }

        loading       = true;
        var $loadMore = $(this);

        // Show loading gif
        $loadMore
            .css({
                width: $(this).outerWidth(),
                height: $(this).outerHeight()
            })
            .addClass('loading')
            .html($('<img>')
                .attr({
                    src: '/assets/images/loader.gif'
                }).css({
                    width: '45px'
                })
            );

        $(this).blur();

        $.get($(this).attr('href'), function (html) {
            var $html = $(html);

            $html.find('[data-paginate] > *').appendTo("[data-paginate]");

            loading = false;

            if ($html.find('[data-load-more]').length) {
                $loadMore
                    .removeClass('loading')
                    .text('Load More')
                    .attr('href', $html.find('[data-load-more]').attr('href'));
                return;
            }

            $loadMore.remove();
        });
    });
});

function getParameterByName(name, url) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
